/**
 * data-target: a selector (including '.', '#') for the element that will animate. the target needs to be a child of <hh-animate-on-display>
 * data-trigger: a selector for the element that triggers the animation (this can be anywhere in the document)
 * data-class: class to be applied
 */

class HHAnimateOnDisplay extends HTMLElement {
  constructor() {
    super()

    this.handleTransitionEnd = this.handleTransitionEnd.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  connectedCallback() {
    setTimeout(() => {
      this.trigger = document.querySelector(this.dataset.trigger)
      this.target = this.querySelector(this.dataset.target)
      this.toggleClass = this.dataset.class

      this.target?.addEventListener('transitionend', this.handleTransitionEnd)
      this.trigger?.addEventListener('click', this.handleChange)

      this.handleTransitionEnd()
    }, 0)
  }

  disconnectedCallback() {
    this.target?.removeEventListener('transitionend', this.handleTransitionEnd)
    this.trigger?.removeEventListener('click', this.handleChange)
  }

  handleChange() {
    const isHidden = this.target.classList.contains(this.toggleClass)

    if (isHidden) {
      this.target.style.removeProperty('display')
      setTimeout(() => this.target.classList.remove(this.toggleClass), 0)
    } else {
      this.target.classList.add(this.toggleClass)
    }
  }

  handleTransitionEnd() {
    const isHidden = this.target?.classList.contains(this.toggleClass)
    if (isHidden) {
      this.target.style.display = 'none'
    }
  }
}

customElements.define('hh-animate-on-display', HHAnimateOnDisplay)
